import {memo, useContext} from 'react';
import TextError from '@/components/Common/TextError';
import {FormContext} from '@/components/Common/FormContextCore';

export {FormProvider, useFormContext} from '@/components/Common/FormContextCore';

/** A field's error message, shown only once the field is touched and has an error (Formik's `<ErrorMessage>`). */
export const FieldError = memo(function FieldError({name}: {name: string}) {
    const form = useContext(FormContext);
    const error = form?.errors[name];
    return form?.touched[name] && error ? <TextError>{error}</TextError> : null;
});
